import api from '@/services/api'

export async function startTest() {
  const { data } = await api.patch('/fluency-test/start')
  return data
}
